import { resetState } from './actions';

export default {
  onVisit: resetState()
};
